import React, { ComponentProps, forwardRef } from 'react';
import {
  toggleButtonClasses,
  ToggleButtonGroup as ToggleButtonGroupMUI,
  toggleButtonGroupClasses,
} from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

import { ShapeProp } from '@/mui/types';

import { countValidChildren } from '@/mui/helpers';

type Props = ComponentProps<typeof ToggleButtonGroupMUI> & {
  equalWidth?: boolean;
  shape?: ShapeProp;
};

const ToggleButtonGroup = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { equalWidth, shape, sx, children, ...rest } = props;

  const childCount = countValidChildren(children) || 0;

  return (
    <ToggleButtonGroupMUI
      ref={ref}
      {...rest}
      sx={{
        ...(equalWidth && {
          display: 'inline-grid',
          gridTemplateColumns: `repeat(${childCount}, 1fr)`,
          [`& .${toggleButtonClasses.root}`]: {
            minWidth: 'max-content',
          },
        }),
        ...(shape === SHAPE_SQUARE && {
          borderRadius: 0,
          [`& .${toggleButtonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          [`& .${toggleButtonGroupClasses.lastButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        }),
        ...(shape === SHAPE_CIRCULAR && {
          borderRadius: (theme) => theme.shape.borderRadiusCircular,
          [`& .${toggleButtonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: (theme) => theme.shape.borderRadiusCircular,
            borderBottomLeftRadius: (theme) => theme.shape.borderRadiusCircular,
          },
          [`& .${toggleButtonGroupClasses.lastButton}`]: {
            borderTopRightRadius: (theme) => theme.shape.borderRadiusCircular,
            borderBottomRightRadius: (theme) => theme.shape.borderRadiusCircular,
          },
        }),
        ...sx,
      }}
    >
      {children}
    </ToggleButtonGroupMUI>
  );
});

ToggleButtonGroup.displayName = 'ToggleButtonGroup';

export default ToggleButtonGroup;
